export { default } from './SmallCenteredText';
